import { logger } from '@teko/log';

const LS_POLICIES_CONFIRMED_USER_IDS = "policiesConfirmedUserIds";
const isSacombankmbPartner = (partner) => {
  return partner === "sacombankmb";
};
const checkShowConfirmPolicyModal = (userId) => {
  const stringUserIds = localStorage == null ? void 0 : localStorage.getItem(LS_POLICIES_CONFIRMED_USER_IDS);
  if (stringUserIds) {
    try {
      const userIds = JSON.parse(stringUserIds);
      return !(userIds == null ? void 0 : userIds.includes(userId || ""));
    } catch (e) {
      logger.error(e);
    }
  }
  return true;
};
const userConfirmedPolicy = (userId) => {
  const stringUserIds = localStorage == null ? void 0 : localStorage.getItem(LS_POLICIES_CONFIRMED_USER_IDS);
  if (stringUserIds) {
    try {
      const userIds = JSON.parse(stringUserIds);
      if (userIds && !userIds.includes(userId)) {
        userIds.push(userId);
        localStorage == null ? void 0 : localStorage.setItem(LS_POLICIES_CONFIRMED_USER_IDS, JSON.stringify(userIds));
        return;
      }
    } catch (e) {
      logger.error(e);
    }
  }
  localStorage == null ? void 0 : localStorage.setItem(LS_POLICIES_CONFIRMED_USER_IDS, `["${userId}"]`);
};

export { checkShowConfirmPolicyModal, isSacombankmbPartner, userConfirmedPolicy };
